import { __ } from '@wordpress/i18n';
import {__experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon} from '@wordpress/components';
import {VayuBlocksColor,VayuBlocksMedia,VayuBlocksGradient, VayuBlocksVideo} from "@vayu-blocks";
import { BgGraclr, BgImg} from '../../helpers/icon.js';
import  { ReactComponent as Icon11 } from '../../../../inc/assets/img/11.svg';
import { FaVideo } from "react-icons/fa6";

export const VayuBlocksColorControl = ({background,onChange, video = false}) =>{

  const { value, backgroundKey } = background;

  const onAdvanceBackgroundChange = (subValue) => {
    const updatedBackground = {
      ...value, 
      'type': subValue,
    };
    onChange(backgroundKey,updatedBackground);
  };

    return ( 
              <>
                <div className="vb-color-image-control">
                  <ToggleGroupControl
                    __next40pxDefaultSize={true}
                    __nextHasNoMarginBottom={true}
                    isDeselectable
                    className="vb-color-image-control-toggle-border"
                    label="Background Type"
                    onChange={onAdvanceBackgroundChange}
                    value={value?.type || 'color'}
                  >
                    <ToggleGroupControlOptionIcon
                      className='vb-color-image-control-color'
                      icon={Icon11}
                      label="Color"
                      value="color"
                    />
                    <ToggleGroupControlOptionIcon
                      className={`vb-color-image-control-media ${
                        value?.type === 'media' ? 'selected-toggle-group-control' : ''
                      }`}
                      icon={BgImg}
                      label="Media"
                      value="media"
                    />
                    <ToggleGroupControlOptionIcon
                      className='vb-color-image-control-gradient'
                      icon={BgGraclr}
                      label="Gradient"
                      value="gradient"
                    />

                    {video && (
                      <ToggleGroupControlOptionIcon
                        className={`vb-color-image-control-media-video ${
                          value?.type === 'video' ? 'selected-toggle-group-control' : ''
                        }`}
                        icon={<FaVideo />}
                        label="Video"
                        value="video"
                      />
                    )}

                  </ToggleGroupControl>
                </div>

                {(!value?.type || value.type === 'color') && 
                  <VayuBlocksColor
                    onChange={onChange}
                    background={background}
                  />
                }
                {value?.type === 'gradient' && 
                  <VayuBlocksGradient
                    onChange={onChange}
                    background={background}
                  /> 
                }
                {value?.type === 'media' && 
                  <VayuBlocksMedia
                    onChange={onChange}
                    background={background}
                  /> 
                }

                {value?.type === 'video' && 
                  <VayuBlocksVideo
                    onChange={onChange}
                    background={background}
                  /> 
                }
            </> 
      )
}